/**
 * GuardianDashboardPage - Guardian management dashboard
 *
 * Surfaces the GuardianDashboard from @/guardian for managing guardians.
 * Provides guardian enrollment, verification status, and access management.
 *
 * Route: /guardian/dashboard
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconUserShield } from '@tabler/icons-react';

import { GuardianDashboard } from '@/guardian';
import { useAuth } from '@/auth/AuthContext';

export function GuardianDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="cyan">
            <IconUserShield size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Guardian Management</Title>
            <Text size="sm" c="dimmed">
              Guardian enrollment, verification status, and access management
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <GuardianDashboard />
    </Container>
  );
}

export default GuardianDashboardPage;
